import { default as React } from 'react';
import { useEntity, EntityRefLinks } from '@backstage/plugin-catalog-react';
import {
  RELATION_OWNED_BY,
  getCompoundEntityRef,
} from '@backstage/catalog-model';
import { InfoCard, MarkdownContent } from '@backstage/core-components';
import { Grid, Typography, Chip } from '@material-ui/core';
import { useAboutCardStyles } from './aboutCardStyles';

/**
 * Custom About card for Domain entities that includes
 * a Tag field showing the entity name slug.
 */
export const DomainAboutCard = ({ variant }: { variant?: 'gridItem' }) => {
  const { entity } = useEntity();
  const classes = useAboutCardStyles();

  const description = entity.metadata?.description || 'No description';

  const ownedByRelations: string[] = (entity.relations || [])
    .filter(r => r.type === RELATION_OWNED_BY)
    .map(r =>
      typeof r.targetRef === 'string'
        ? r.targetRef
        : String(getCompoundEntityRef(r.targetRef as any)),
    );

  return (
    <InfoCard title="About" variant={variant}>
      <Grid container>
        {/* Description */}
        <Grid item xs={12}>
          <Typography variant="h2" className={classes.label}>
            Description
          </Typography>
          <div className={classes.description}>
            <MarkdownContent content={description} />
          </div>
        </Grid>

        {/* Owner */}
        {ownedByRelations.length > 0 && (
          <Grid item xs={12} sm={6} lg={4}>
            <Typography variant="h2" className={classes.label}>
              Owner
            </Typography>
            <Typography variant="body2" className={classes.value}>
              <EntityRefLinks
                entityRefs={ownedByRelations}
                defaultKind="group"
              />
            </Typography>
          </Grid>
        )}

        {/* Tag */}
        <Grid item xs={12} sm={6} lg={4}>
          <Typography variant="h2" className={classes.label}>
            Tag
          </Typography>
          <Chip
            label={entity.metadata.name}
            size="small"
            className={classes.chip}
          />
        </Grid>
      </Grid>
    </InfoCard>
  );
};
